import React from 'react'

import { Button, Card, Icon } from '../../../atoms'

const CallOutBanner = ({ jsonBody = {} }) => {
  return (
    <Card className='CallOutBanner'>
      <div>
        <div className='CallOutBanner__titleWrapper'>
          <div>
            <Icon glyph='business-white' size='26' />
          </div>
          <h3>{jsonBody.title}</h3>
        </div>
        <h4>{jsonBody.subtitle}</h4>
        <ul>
          {jsonBody.items.map((item, index) => {
            return (
              <li key={index}>
                <div>
                  <div className='CallOutBanner__listTitle'>{item.title}</div>
                  <div>{item.body}</div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
      <div>
        <Button href={jsonBody.button.href} variant='secondary'>
          {jsonBody.button.text}
        </Button>
      </div>
    </Card>
  )
}

export default CallOutBanner
